import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
  Card,
  CardContent
} from "@mui/material";
import styles from "../css/Form.module.css";

export default function Form({ onSubmitSuccess }) {
  const preguntas = [
    { id: 1, texto: "¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?", tipo: "texto" },
    { id: 2, texto: "¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?", tipo: "texto" },
    { id: 3, texto: "¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?", tipo: "texto" },
    { id: 4, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?", tipo: "texto" },
    { id: 5, texto: "¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA? ", tipo: "texto" },
    { id: 6, texto: "¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?", tipo: "texto" },
    { id: 7, texto: "¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?", tipo: "texto" },
    { id: 8, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?", tipo: "texto" },
    { id: 9, texto: "¿En el Plan municipal de intervenciones se tiene incluidas intervenciones y recursos del Gobierno municipal?", tipo: "texto" },
    { id: 10, texto: "¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?", tipo: "texto" },
    { id: 11, texto: "¿En su municipio se han priorizado comunidades para intensificar las acciones?", tipo: "texto" },
    { id: 12, texto: "¿Cuántas comunidades han sido priorizadas en su municipio?", tipo: "texto" },
    { id: 13, texto: "¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?", tipo: "texto" },
    { id: 14, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?", tipo: "texto" },
    { id: 15, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? ", tipo: "texto" },
    { id: 16, texto: "¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? ", tipo: "texto" },
    { id: 17, texto: "¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?", tipo: "texto" },
    { id: 18, texto: "¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?", tipo: "texto" },
    { id: 19, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?", tipo: "texto" },
    { id: 20, texto: "¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?", tipo: "texto" },
    { id: 21, texto: "¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?", tipo: "texto" },
    { id: 22, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?", tipo: "texto" },
    { id: 23, texto: "¿En el municipio se cuenta con el registro de familias que han sido beneficiadas programas sociales o institucional?", tipo: "texto" },
    { id: 24, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?", tipo: "texto" },
    { id: 25, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?", tipo: "texto" },
    { id: 26, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?", tipo: "texto" },
    { id: 27, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?", tipo: "texto" },
    { id: 28, texto: "¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?", tipo: "texto" },
    { id: 29, texto: "¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?", tipo: "texto" },
  ];

  const [formData, setFormData] = useState({
    departamento: "",
    respuestas: {}
  });

  const [departamentos, setDepartamentos] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [loading, setLoading] = useState(false);

  const [confirmDialog, setConfirmDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const [isActivePeriod, setIsActivePeriod] = useState(true);
  const [periodMessage, setPeriodMessage] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingPeriod, setCheckingPeriod] = useState(true);
  const [departamentoAlreadyResponded, setDepartamentoAlreadyResponded] = useState(false);

  const checkActivePeriod = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const formId = 'form3';
      
      if (user) {
        const userParam = encodeURIComponent(JSON.stringify(user));
        const res = await fetch(`/check-period/${formId}?user=${userParam}`);
        const data = await res.json();
        
        setIsActivePeriod(data.isActive);
        setPeriodMessage(data.message);
        setIsAdmin(data.isAdmin || false);
      } else {
        const res = await fetch(`/check-period/${formId}`);
        const data = await res.json();
        
        setIsActivePeriod(data.isActive);
        setPeriodMessage(data.message);
        setIsAdmin(false);
      }
    } catch (err) {
      console.error("Error al verificar periodo:", err);
      setIsActivePeriod(false);
      setPeriodMessage("Error al verificar periodo activo");
      setIsAdmin(false);
    } finally {
      setCheckingPeriod(false);
    }
  };

  const verificarRespuestaDepartamento = async () => {
    try {
      if (!formData.departamento) {
        setDepartamentoAlreadyResponded(false);
        return;
      }

      const res = await fetch(
        `/check-departamento-response/${formData.departamento}`
      );
      
      if (res.ok) {
        const data = await res.json();
        setDepartamentoAlreadyResponded(data.exists && !isAdmin);
        
        if (data.exists && !isAdmin) {
          setSnackbar({
            open: true,
            message: "⚠️ Ya se ha enviado una respuesta para este departamento este mes",
            severity: "warning"
          });
        }
      }
    } catch (err) {
      console.error("Error verificando respuesta de departamento:", err);
      setDepartamentoAlreadyResponded(false);
    }
  };

  useEffect(() => {
    checkActivePeriod();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    fetch(`/user-location?username=${user.username}`)
      .then(res => res.json())
      .then(data => {
        setUserLocation(data);

        if (data.type === "department") {
          setFormData(prev => ({
            ...prev,
            departamento: data.departamentoId
          }));
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    fetch(`/departamentos`)
      .then(res => res.json())
      .then(data => setDepartamentos(data));
  }, []);

  useEffect(() => {
    if (formData.departamento) {
      verificarRespuestaDepartamento();
    } else {
      setDepartamentoAlreadyResponded(false);
    }
  }, [formData.departamento, isAdmin]);

  useEffect(() => {
    const verificarAlCargar = async () => {
      if (formData.departamento && !checkingPeriod) {
        await verificarRespuestaDepartamento();
      }
    };

    verificarAlCargar();
  }, [formData.departamento, checkingPeriod, isAdmin]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isActivePeriod && !isAdmin) {
      setSnackbar({
        open: true,
        message: "No se puede enviar el formulario fuera del periodo activo",
        severity: "warning",
      });
      return;
    }

    if (departamentoAlreadyResponded && !isAdmin) {
      setSnackbar({
        open: true,
        message: "Ya se ha enviado una respuesta para este departamento este mes",
        severity: "warning",
      });
      return;
    }

    if (!formData.departamento) {
      setSnackbar({
        open: true,
        message: "Debes seleccionar un departamento.",
        severity: "warning",
      });
      return;
    }

    const faltantes = preguntas.filter(
      (p) =>
        !formData.respuestas[p.id] &&
        formData.respuestas[p.id] !== 0
    );

    if (faltantes.length > 0) {
      setSnackbar({
        open: true,
        message: "Responde todas las preguntas antes de guardar.",
        severity: "warning",
      });
      return;
    }

    setConfirmDialog(true);
  };

  const handleCargarPreviasDenominadores = async () => {
    if (!formData.departamento) {
      setSnackbar({
        open: true,
        message: "Selecciona un departamento para cargar datos previos.",
        severity: "warning"
      });
      return;
    }

    try {
      const res = await fetch(
        `/denominadores/${formData.departamento}`
      );

      const data = await res.json();

      if (!data.success) {
        setSnackbar({
          open: true,
          message: "No hay registros previos.",
          severity: "info"
        });
        return;
      }

      setFormData(prev => ({
        ...prev,
        respuestas: data.respuestas
      }));

      setSnackbar({
        open: true,
        message: `Respuestas del ${data.mes}/${data.anio} cargadas.`,
        severity: "success"
      });

    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Error al cargar respuestas previas.",
        severity: "error"
      });
    }
  };

  const handleConfirmSubmit = async () => {
    setConfirmDialog(false);
    setLoading(true);

    const user = JSON.parse(localStorage.getItem("user"));

    const payload = {
      userId: user.id,
      departamentoId: formData.departamento,
      Dpregunta: formData.respuestas
    };

    try {
      const res = await fetch(`/denominadores`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Error al guardar los datos");
      }

      const result = await res.json();

      setSnackbar({
        open: true,
        message: `✅ Datos guardados correctamente. ${result.isAdmin ? '(Modo administrador)' : ''}`,
        severity: "success"
      });

      setFormData(prev => ({
        departamento: userLocation?.departamentoId ?? "",
        respuestas: {}
      }));

      setDepartamentoAlreadyResponded(true);
      
      if (onSubmitSuccess) onSubmitSuccess();

    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error al guardar datos.",
        severity: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  if (checkingPeriod) {
    return (
      <Paper elevation={6} className={styles.paper}>
        <Typography variant="h5" gutterBottom className={styles.title}>
          Ingresar Nueva Respuesta
        </Typography>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1">Verificando periodo activo...</Typography>
        </Box>
      </Paper>
    );
  }

  if (!isActivePeriod && !isAdmin) {
    return (
      <Paper elevation={6} className={styles.paper}>
        <Card sx={{ textAlign: 'center', py: 4 }} className={styles.inactivePeriod}>
          <CardContent>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Período Inactivo
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {periodMessage || "El formulario solo está disponible los primeros 8 días de cada mes."}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Por favor, regrese durante el periodo activo para llenar el formulario.
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    );
  }

  return (
    <Paper elevation={6} className={styles.paper}>
      <Typography variant="h5" gutterBottom className={styles.title}>
        Ingresar Nueva Respuesta
        {isAdmin && " (Modo Administrador)"}
      </Typography>

      <Alert 
        severity={isAdmin ? "info" : (isActivePeriod ? "success" : "warning")} 
        sx={{ mb: 3 }}
      >
        {isAdmin ? "Modo administrador - Sin restricciones de tiempo" : periodMessage}
      </Alert>

      {departamentoAlreadyResponded && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          ⚠️ Este departamento ya tiene una respuesta registrada este mes.
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} className={styles.formContainer}>

        <TextField
          select
          fullWidth
          required
          label="Departamento"
          value={formData.departamento}
          disabled={userLocation?.type === "department"}
          onChange={(e) =>
            setFormData(prev => ({ ...prev, departamento: e.target.value }))
          }
          sx={{ mb: 2 }}
          error={departamentoAlreadyResponded}
        >
          {departamentos.map(dep => (
            <MenuItem key={dep.departamentoId} value={dep.departamentoId}>
              {dep.departamentoName}
            </MenuItem>
          ))}
        </TextField>

        <Button
          variant="outlined"
          sx={{ mb: 3 }}
          disabled={!formData.departamento || departamentoAlreadyResponded}
          onClick={handleCargarPreviasDenominadores}
          fullWidth
        >
          Cargar Respuestas Previas
        </Button>

        {preguntas.map((preg) => (
          <Box key={preg.id} sx={{ mb: 2 }}>
            <Typography>{preg.id}. {preg.texto}</Typography>

            <TextField
              fullWidth
              value={formData.respuestas[preg.id] || ""}
              onWheel={(e) => e.target.blur()}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  respuestas: { ...prev.respuestas, [preg.id]: e.target.value }
                }))
              }
              type="number"
            />
          </Box>
        ))}

        <Button 
          type="submit" 
          variant="contained" 
          fullWidth 
          disabled={loading || (departamentoAlreadyResponded && !isAdmin)}
          className={styles.submitButton}
        >
          {loading ? "Guardando..." : 
           departamentoAlreadyResponded && !isAdmin ? "✅ Departamento ya respondido" : "Guardar"}
        </Button>
      </Box>

      <Dialog open={confirmDialog} onClose={() => setConfirmDialog(false)}>
        <DialogTitle>Confirmar envío</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro de enviar los datos?
            {isAdmin && <><br/><strong>Modo administrador: Sin restricciones de tiempo</strong></>}
            {departamentoAlreadyResponded && isAdmin && <><br/><strong>⚠️ Este departamento ya tiene respuesta (modo admin permite reemplazar)</strong></>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog(false)}>Cancelar</Button>
          <Button onClick={handleConfirmSubmit} variant="contained">Confirmar</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Paper>
  );
}